module.exports = __webpack_public_path__ + "static/media/configuration.a8fc5622.png";